<template>
  <div>
    <v-container fluid class="grey-container cta-container" :style="containerStyle">
      <v-container class="contain-width">
        <v-row>
          <v-col
              cols="12"
              md="10"
              offset-md="1"
          >
            <v-card
                v-if="loading"
                class="mx-auto"
                elevation="5"
            >
              <v-sheet
                  :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
                  class="pa-3"
              >
                <v-skeleton-loader
                    class="mx-auto"
                    type="card-heading, image"
                ></v-skeleton-loader>
              </v-sheet>
            </v-card>
            <v-card
                v-if="organisation"
                class="mx-auto"
                elevation="5"
            >
              <v-card-title class="text-h4 primary--text">{{ organisation.name }} <span><v-icon size="20" color="primary" class="ml-6">mdi-shield-star-outline</v-icon> <span class="overline">{{ $t('A {brand} partner', {brand: brandName}) }}</span></span></v-card-title>

              <v-divider></v-divider>

              <v-card-text class="text--primary">

                <p v-if="organisation.coupon" class="text-h2 text-center mb-6">{{ subscriptionDiscount }}<span class="text-overline ml-3">{{ $t('first years subscription') }}</span> <span class="text-h4"><span class="red--text" style="text-decoration: line-through">{{ originalPrice}}</span> {{ reducedPrice }}</span></p>
                <p v-else class="text-h2 text-center"><span class="text-overline">{{ $t('first years subscription') }}</span> <span class="text-h4">{{ originalPrice }}</span></p>

                <div class="d-flex align-center flex-column justify-center mt-0">
                  <v-btn class="mt-0 mb-6" block x-large elevation="5" color="primary" @click="navigate('sign-up-individual')">
                    {{ $t('buttons.Join now')}}
                  </v-btn>
                </div>

                <div v-if="organisation.landing_image" class="d-flex justify-center mb-6">
                  <v-img
                      contain
                      :src="imagesHost() + organisation.landing_image"
                      :max-height="500"
                      :alt="organisation.name"
                  ></v-img>
                </div>

                <vimeo-player v-if="organisation.landing_video" ref="player" :video-id="organisation.landing_video" @ready="onReady" class="player-container mb-6" :options="options">
                </vimeo-player>
                <vimeo-player v-else ref="player" video-id="410322496" @ready="onReady" class="player-container mb-6" :options="options">
                </vimeo-player>

                <div>

                  <v-alert
                      color="primary"
                      border="left"
                      colored-border
                      type="info"
                      light
                      elevation="2"
                  >

                    <v-row align="center">
                      <v-col class="grow">
                        <p v-if="organisation.landing_alert" class="text-h3 text-left">{{ organisation.landing_alert }}</p>
                        <p v-else class="text-h3 text-left">{{ $t('Join {brand} today to help keep those costs down and the environment cleaner', {brand: brandName}) }}</p>
                      </v-col>
                      <v-col class="shrink">
                        <v-btn elevation="5" color="primary" tile @click="navigate('sign-up-individual')">
                          {{ $t('buttons.Join now') }}
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-alert>

                  <div v-if="organisation.landing_content" class="text-body-1 mt-6 mb-6 no-p-margin" v-html="organisation.landing_content"></div>

                  <h2 class="text-h4 mb-2">{{ $t('headings.What you get') }}</h2>

                  <h3 class="text-h5 mb-2">{{ $t('headings.Your smart tag bundle includes') }}:</h3>

                  <ul class="mb-6 text-body-1">
                    <li>{{ $t('25 iron on labels') }}</li>
                    <li>{{ $t('25 sticker labels') }}</li>
                    <li>{{ $t('3 key tags') }}</li>
                    <li>{{ $t('1 two part bag tag') }}</li>
                    <li>{{ $t('1 recovery card') }}</li>
                    <li>{{ $t('Unlimited SMS notifications for found items') }}</li>
                    <li>{{ $t('Free use of our app (android/ios)') }}</li>
                    <li>{{ $t('Access to our {brand} returns system', {brand: brandName}) }}</li>
                  </ul>

                  <h2 v-if="organisation.landing_competition_title" class="text-h4 mb-2">{{ organisation.landing_competition_title }}</h2>
                  <p v-if="organisation.landing_competition_summary" class="text-body-1">{{ organisation.landing_competition_summary }}</p>
                  <div v-if="organisation.landing_competition_image" class="d-flex justify-center mb-6">
                    <v-img
                        class="mr-3 mr-sm-6 ml-3 ml-sm-6"
                        :src="imagesHost() + organisation.landing_competition_image"
                        contain
                        :alt="organisation.landing_competition_title"
                    ></v-img>
                  </div>

                  <h2 class="text-h4 mb-2">{{ $t('headings.How it works') }}</h2>
                  <p class="text-body-1">{{ $t('{brand} have revolutionised the traditional name tag, and created a lost property returns system using QR code technology.', {brand: brandName}) }}</p>
                  <p class="text-body-1">{{ $t('Once your bundle arrives, simply activate your tags - its quick and easy.') }}</p>
                  <p class="text-body-1">{{ $t('A missing item with one of our tags affixed can be scanned by the finder and an alert will be sent by text and email to its owner.') }}</p>
                  <p class="text-body-1">{{ $t('If the tag was scanned by an organisation, then the alert will advise that the item has been found, and where to collect it from.') }}</p>
                  <p class="text-body-1">{{ $t('If the alert has been generated from a member of the public you will receive an email explaining how the {brand} returns process we will help facilitate the return of your item.', {brand: brandName}) }}</p>
                  <p class="text-body-1">{{ $t("Don't worry we have carefully designed the process so it is anonymous and safe.") }}</p>
                  <p class="text-body-1">{{ $t("If you don't want to use the public lost property returns system – no problem, you have full control from your account page to set the privacy of the tags to registered organisations only.") }}</p>
                </div>

                <p v-if="organisation.coupon" class="text-h2 text-center mb-6">{{ subscriptionDiscount }}<span class="text-overline ml-3">{{ $t('headings.first years subscription') }}</span> <span class="text-h4"><span class="red--text" style="text-decoration: line-through">{{ originalPrice}}</span> {{ reducedPrice }}</span></p>
                <p v-else class="text-h2 text-center"><span class="text-overline">{{ $t('headings.first years subscription') }}</span> <span class="text-h4">{{ originalPrice }}</span></p>

                <v-btn class="mt-3 mb-6" block x-large elevation="5" color="primary" @click="navigate('sign-up-individual')">
                  {{ $t('buttons.Join now') }}
                </v-btn>
              </v-card-text>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Footer />
    <CookieAcceptDecline />
  </div>
</template>

<script>

import Footer from './Footer'
import CookieAcceptDecline from './CookieAcceptDecline'
import { mapActions, mapState } from 'vuex'
import axios from 'axios';
import {i18n} from "../i18n";

export default {
  name: "Landing",
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  metaInfo () {
    return {
      title: this.brand + ' - ' + `${this.metaTitle}`,
      htmlAttrs: {
        lang: i18n.locale
      },
      meta: [
        { name: 'description', content: `${this.metaDescription}` },
        { name: 'keywords', content: `${this.keywords}` },
        { property: 'og:title', content: `${this.metaTitle}` },
        { property: 'og:description', content: `${this.metaDescription}` },
        { property: 'og:image', content: `${this.imageSocial}` },
        { property: 'og:url', content: `${this.url}` },
        { name: 'twitter:title', content: `${this.name}` },
        { name: 'twitter:description', content: `${this.metaDescription}` },
        { name: 'twitter:image', content: `${this.imageSocial}` },
        { name: 'twitter:card', content: 'summary_large_image' }
      ],
      link: this.links
    }
  },
  components: {
    Footer,
    CookieAcceptDecline
  },
  props: ['slug'],
  data () {
    return {
      options: {'responsive': true, 'dnt': true, 'autoplay': true, 'loop': true},
      playerReady: false,
      organisation: null,
      metaTitle: '',
      metaDescription: '',
      imageSocial: '',
      loading: true
    }
  },
  mounted () {

    if (this.$route.query.success) {
      this.thanksDialog = true;
    }

    this.$gtag.pageview({
      page_path: '/sign-up/' + this.slug
    })

    document.getElementById("scrolling-content").scrollTop = 0

    window.prerenderReady = true;

    if (this.slug) {

      this.referringOrganisation(this.slug).then(() => {
        console.log(this.slug)

        const instance = axios.create({
          baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        });

        instance
            .get('/api/organisations/enabled?brand=' + this.brand)
            .then(response => {
              if (response.status === 200) {
                console.log(response.data.data)
                let activeOrganisations = response.data.data

                for (let x in activeOrganisations) {
                  if (activeOrganisations[x].slug && this.organisationSlug && activeOrganisations[x].slug === this.organisationSlug) {
                    this.organisation = activeOrganisations[x]
                  }
                }

                console.log(this.organisation)

                if (this.organisation === null) {
                  this.$router.push({name: 'sign-up-individual'})
                }
              }
            })
            .catch(error => {
              console.log(error)
            })
            .finally(() => {
              this.loading = false
              window.prerenderReady = true;
            })
      })
    }
    else {
      this.referringOrganisation(null).then(() => {
        this.organisation = null;
      })
    }
  },
  methods: {
    ...mapActions(['referringOrganisation']),
    imagesHost() {
      return process.env.VUE_APP_IMAGES_HOST
    },
    navigate(routeName) {
      this.$router.push({name: routeName})
    },
    onReady() {
      this.playerReady = true
    },
    play () {
      this.$refs.player.play()
    },
    stop () {
      this.$refs.player.stop()
    }
  },
  computed: {
    ...mapState({
      organisationSlug: state => state.referringOrganisation,
      brand: state => state.brand,
brandName: state => state.brandName
    }),
    containerStyle() {
      if (this.organisation && this.organisation.landing_background) {
        return { 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + process.env.VUE_APP_IMAGES_HOST + this.organisation.landing_background + ')' }
      }
      else {
        return {}
      }

    },
    videoId() {
      if (this.slug === 'rosslyn-park-national-7s-lost-property-system') {
        return '678649371'
      }
      else {
        return '410322496'
      }
    },
    subscriptionDiscount() {
      if (this.organisation.coupon) {

        if (this.brand === 'neotag') {
          if (this.organisation.coupon.amount_off === (process.env.VUE_APP_SUBSCRIPTION_EUR * 100)) {
            return 'FREE '
          }

          // let discount = this.organisation.coupon.amount_off / 100
          // return ((discount / process.env.VUE_APP_SUBSCRIPTION_EUR) * 100) + '% off '
          return '€' + (this.organisation.coupon.amount_off / 100) + ' ' + i18n.t('off')
        }
        else {
          if (this.organisation.coupon.amount_off === (process.env.VUE_APP_SUBSCRIPTION_GBP * 100)) {
            return 'FREE '
          }

          // let discount = this.organisation.coupon.amount_off / 100
          // return ((discount / process.env.VUE_APP_SUBSCRIPTION_GBP) * 100) + '% off '
          return '£' + (this.organisation.coupon.amount_off / 100) + ' ' + i18n.t('off')
        }
      }
      return null
    },
    originalPrice() {
      if (this.brand === 'neotag') {
        return '€' + process.env.VUE_APP_SUBSCRIPTION_EUR
      }
      else {
        return '£' + process.env.VUE_APP_SUBSCRIPTION_GBP
      }
    },
    reducedPrice() {
      if (this.organisation.coupon) {
        if (this.brand === 'neotag') {
          return '€' + (process.env.VUE_APP_SUBSCRIPTION_EUR - (this.organisation.coupon.amount_off / 100))
        }
        else {
          return '£' + (process.env.VUE_APP_SUBSCRIPTION_GBP - (this.organisation.coupon.amount_off / 100))
        }
      }
      return null
    },
  }
}
</script>

<style>
.v-card__actions {
  padding: 16px;
  justify-content: flex-end;
}
.info-card {
  border: none !important;
}
.no-p-margin p {
  margin-bottom: 0;
}
</style>
